export default __webpack_public_path__ + "static/media/app1.b23b9bd5.svg";